// extracted by mini-css-extract-plugin
export var chevronIcon = "_ao-2";
export var teamName = "_ao-1";
export var teamSwitcherButton = "_ao-0";